import App from '@/models/App'
import ShipLaborWork from './ShipLaborWork'

export default class ShipLaborAttendanceSailor extends App {
    static get entity() {
        return 'ShipLaborAttendanceSailor'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static get activeStamps() {
        return this.query()
            .with('shipLaborWork')
            .orderBy('openedAt')
            .get()
            .filter((value) => {
                const { shipLaborWork } = value
                return shipLaborWork && shipLaborWork.name !== '休憩'
            })
    }
    static getStampsByTimeWith(start, end) {
        return this.query()
            .with('shipLaborWork')
            .where(
                ({ openedAt, closedAt }) => closedAt > start && openedAt < end
            )
            .orderBy('openedAt')
            .get()
            .filter((value) => {
                const { shipLaborWork, isPlan } = value
                return shipLaborWork && shipLaborWork.name !== '休憩' && !isPlan
            })
    }
    static getWorkingStampsByTimeWith(start, end) {
        return this.query()
            .with('shipLaborWork')
            .where(
                ({ openedAt, closedAt }) => closedAt > start && openedAt < end
            )
            .orderBy('openedAt')
            .get()
            .filter((value) => {
                const { shipLaborWork, openedAt, closedAt } = value
                if (shipLaborWork) {
                    if (shipLaborWork.name === '休憩') {
                        return false
                    } else if (shipLaborWork.name === '操練等') {
                        return (
                            openedAt >= '2023-04-01 00:00:00' ||
                            closedAt >= '2023-04-01 00:00:00'
                        )
                    } else {
                        return shipLaborWork.isWork
                    }
                } else {
                    return false
                }
            })
    }
    static fields() {
        return {
            id: this.attr(''),
            closedAt: this.attr(''),
            openedAt: this.attr(''),
            isPlan: this.attr(false),
            shipId: this.attr(''),
            shipLaborWorkId: this.attr(''),
            shipLaborWork: this.belongsTo(ShipLaborWork, 'shipLaborWorkId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(
                organizationId,
                shipSailorId,
                openedAt,
                closedAt,
                period,
                save = true
            ) {
                return this.get(
                    `organizations/${organizationId}/sailors/${shipSailorId}/labor/attendances/all`,
                    {
                        params: { openedAt, closedAt, period },
                        save,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
